import { GDFHotPollyShape, GDFPalletCode } from '../../../gdf/type';
import palettes from '../../../palettes/palettes';
import { generateColorExpressionFromPalette } from '../../../utils/ramp';
import { StyleFactory } from '../styling';

export const airmetsLayer: StyleFactory = (baseId) => {
    // I only have seen line and polygon types
    const colors = generateColorExpressionFromPalette(palettes[GDFPalletCode.airmets], ['get', 'type']);
    return [
        {
            type: 'line',
            id: baseId + '-line',
            source: baseId,
            pickable: true,
            // Draw lines for polygons as well so that we have a nice outline
            filter: ['==', ['get', 'shape'], GDFHotPollyShape.line],
            paint: {
                'line-color': colors,
                'line-width': ['interpolate', ['linear'], ['zoom'], 0, 1, 4, 2]
            }
        },
        {
            type: 'fill',
            source: baseId,
            id: baseId + '-fill',
            pickable: true,
            filter: ['==', ['get', 'shape'], GDFHotPollyShape.polygon],
            paint: {
                'fill-color': colors,
                'fill-outline-color': colors,
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            type: 'line',
            source: baseId,
            id: baseId + '-fill-outline',
            filter: ['==', ['get', 'shape'], GDFHotPollyShape.polygon],
            paint: {
                'line-color': colors,
                'line-width': ['interpolate', ['linear'], ['zoom'], 0, 0, 2, 1, 4, 2]
            }
        },
        {
            type: 'fill',
            source: baseId,
            id: baseId + '-hover',
            filter: ['==', ['get', 'shape'], GDFHotPollyShape.polygon],
            paint: {
                'fill-color': ['case', ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)', 'rgba(0,0,0,0)']
            }
        }
    ];
};
